import { atom } from "jotai";

import { type QueryMetadata } from "./types";

export const queryMetadataAtom = atom<QueryMetadata[]>([]);
export const adminModalIsOpenAtom = atom(false);
